import { FC } from 'react';
import PaidLeavePeriodField from '../field/LeavePeriodField';
import PaidLeaveColumnLayout from '../layout/LeaveColumnLayout';
import PaidLeaveTakenField from '../field/LeaveTakenField';
import AvailableField from '../field/AvailableField';
import LeavesDataGridLayout from '../layout/LeavesDataGridLayout';
import PaidLeavesSectionHeader from '../shared/PaidLeavesSectionHeader';
import BalanceDisplayField from '../field/BalanceDisplayField';
import { ProcessedLeaveYear } from '../../shared/types';
import { RelatedList, RelationListLayout } from 'framework/list';
import EmployeeSectionWrapper from 'domain/people/employee/shared/EmployeeSectionWrapper';
import PaidLeaveDetailsField from '../field/PaidLeaveDetailsField';
import { Data } from 'framework/types';

interface PaidLeavesSectionProps {
  getPaidLeavesDataMethod: () => Promise<{ result: ProcessedLeaveYear[] }>;
  compactMode?: boolean;
  defaultExpandedItems?: (data: ProcessedLeaveYear) => boolean;
  hideShowDetailsButtons?: boolean;
}

const PaidLeavesSection: FC<PaidLeavesSectionProps> = ({
  getPaidLeavesDataMethod,
  compactMode = false,
  defaultExpandedItems,
  hideShowDetailsButtons = false,
}) => {
  const isExpandableItem = (data: Data<ProcessedLeaveYear>) => {
    return data?.leaves?.length > 0;
  };

  return (
    <EmployeeSectionWrapper>
      <RelatedList getDataMethod={getPaidLeavesDataMethod}>
        <RelationListLayout header={<PaidLeavesSectionHeader />}>
          <LeavesDataGridLayout
            expandable
            isExpandableItem={isExpandableItem}
            expandableSection={<PaidLeaveDetailsField hideShowDetailsButtons={hideShowDetailsButtons} />}
            defaultExpandedItems={defaultExpandedItems}
          >
            <PaidLeaveColumnLayout label="Period" size={compactMode ? 12 : 4}>
              <PaidLeavePeriodField />
            </PaidLeaveColumnLayout>
            {!compactMode && (
              <PaidLeaveColumnLayout label="Balance" size={2}>
                <BalanceDisplayField
                  balanceField="paidLeavesTotalBalance"
                  dayOnDemandField="dayOnDemandsTotalBalance"
                />
              </PaidLeaveColumnLayout>
            )}
            {!compactMode && (
              <PaidLeaveColumnLayout label="Available" size={3.5}>
                <AvailableField
                  balanceField="paidLeavesRemainedBalance"
                  dayOnDemandField="dayOnDemandsRemainedBalance"
                  expiredBalanceField="paidLeavesExpiredBalance"
                />
              </PaidLeaveColumnLayout>
            )}
            {!compactMode && (
              <PaidLeaveColumnLayout label="Taken" size={2.5}>
                <PaidLeaveTakenField showDaysOnDemand />
              </PaidLeaveColumnLayout>
            )}
          </LeavesDataGridLayout>
        </RelationListLayout>
      </RelatedList>
    </EmployeeSectionWrapper>
  );
};

export default PaidLeavesSection;
